import { injectable, inject } from 'inversify';
import { MultipartUploadStrategy, UploadDispatcher, UploadAdapter } from '@dealroadshow/file-uploader';
import { dataroomUrl } from '@dataroom/url';
import { DILogoUploadTypes } from './DI/types';
import { DataroomTenant } from '@dataroom/tenant/DataroomTenant';
import { DataroomTenantContextSymbol, type IDataroomTenantContext } from '@dataroom/tenant/types';
import { validateDataroomTenant } from '@dataroom/tenant/validateDataroomTenant';
import Container from '@framework/di/Container';
import { type ILogoSocketProcessingAdapterMethod as ILogoSocketProcessingAdapterFactory } from './DI/interfaces';

@injectable()
class LogoUploadDispatcherFactory {
  constructor(
    @inject(Container) private readonly container: Container,
    @inject(
      DILogoUploadTypes.LogoSocketProcessingAdapter,
    ) private readonly logoSocketProcessingAdapterFactory: ILogoSocketProcessingAdapterFactory,
  ) {}

  create = (tenantCode: DataroomTenant | null = null) => {
    const tenant = tenantCode || this.container.get<IDataroomTenantContext>(DataroomTenantContextSymbol).tenant;
    validateDataroomTenant(tenant);

    const uploadAdapter = new UploadAdapter({
      url: dataroomUrl(tenant)
        .getUploadLogoUrl(),
    });
    const processingAdapter = this.logoSocketProcessingAdapterFactory(tenant);
    return new UploadDispatcher(new MultipartUploadStrategy(uploadAdapter, processingAdapter));
  };
}

export default LogoUploadDispatcherFactory;
